"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderMSAtWorkVideoCard = renderMSAtWorkVideoCard;
exports.renderMarketingTestimonial = renderMarketingTestimonial;

var _react = _interopRequireDefault(require("react"));

var _ModalVideoLauncherCard = _interopRequireDefault(require("../components/ModalVideoLauncherCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderMarketingTestimonial(videoModal) {
  var videoTestimonialProps = {
    videoModal: videoModal,
    videoSource: "https://player.vimeo.com/video/378881542?autoplay=1&title=0&byline=0",
    videoPreviewImageSource: require("../assets/redesign2020/marketing-video-testimonial/anderson.png"),
    videoGoogleAnalyticsName: "clientStories",
    logoProps: {
      altText: "Andersen Tax",
      source: require("../assets/redesign2020/marketing-video-testimonial/anderson-logo.png")
    },
    textBodyProps: {
      textBodyHeader: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Why Andersen Tax ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "invests in their people"), "."),
      textBodyContent: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Andersen Tax wanted to provide a relevant benefit for their employees in hopes of easing their student debt burden. Launching a Student Loan PayDown program spoke volumes to their workforce and is a component of what they strive to build culturally.")
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ModalVideoLauncherCard.default, videoTestimonialProps);
}

function renderMSAtWorkVideoCard(videoModal) {
  var msAtWorkVideoProps = {
    videoModal: videoModal,
    videoSource: "https://player.vimeo.com/video/507676807?autoplay=1&title=0&byline=0",
    videoPreviewImageSource: require("../assets/home/msaw-placeholder.jpg"),
    videoGoogleAnalyticsName: "msAtWork",
    logoProps: null,
    textBodyProps: {
      textBodyHeader: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Gradifi by ", /*#__PURE__*/_react.default.createElement("span", {
        className: "solutions-etrade-logo"
      }, "E", /*#__PURE__*/_react.default.createElement("img", {
        className: "solutions-etrade-icon-large",
        alt: "ETRADE Logo",
        src: require("../assets/redesign2020/etrade-icon.svg")
      }), "TRADE"), " ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, " is part of the Morgan Stanley at Work suite of solutions.")),
      textBodyContent: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Innovative workplace offerings for companies and employees across Equity Compensation, Financial Wellness, and Retirement Solutions and service offerings to support the full spectrum of wealth.")
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ModalVideoLauncherCard.default, msAtWorkVideoProps);
}